import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/base";
import { FormHelperText, MenuItem } from "@mui/material";
import { ErrorMessage } from "@hookform/error-message";
import { MyInputLable } from "./standardLable";

const SelectInput = ({
  defaultValue,
  label,
  name,
  required,
  placeholder,
  data,
  valueName,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ? defaultValue : ""}
      render={({ field: { onChange, value } }) => (
        <div className={"mb-10"}>
          <MyInputLable htmlFor={name} required={required}>
            {label}
          </MyInputLable>
          <div className="mt-3">
            <StadardSelect
              fullWidth
              size="small"
              value={value}
              placeholder={placeholder}
              onChange={onChange}
              id={name}
              sx={{ border: "none", "& fieldset": { border: "none" } }}
            >
              {data?.map((item) => (
                <MenuItem key={item.id} value={valueName ? item.name : item.id}>
                  {item.name ? item?.name : item?.title}
                </MenuItem>
              ))}
            </StadardSelect>
            <ErrorMessage
              render={({ message }) => (
                <FormHelperText sx={{ color: "#f00" }}>
                  {message}
                </FormHelperText>
              )}
              errors={errors}
              name={name}
            />
          </div>
        </div>
      )}
    />
  );
};

export const StadardSelect = styled(Select)`
  && {
    .MuiSelect-select {
      border-radius: 0.6rem;
      width: 100%;
    }
    &.MuiInputBase-root {
      border-radius: 0.6rem;
      width: 100%;
      background: var(--primary-whilte, #eef5ff);

      span {
        line-height: 0 !important;
      }
    }
  }
`;
export default SelectInput;
